// src/stores/cemeteryStore.ts
import { defineStore } from 'pinia'
import { type CemeteryType } from '@/scripts/api'

export const useCemeteryStore = defineStore('cemetery', {
    state: () => ({
        cemetery: null as CemeteryType | null,
        cemetery_cards: [] as any[],
        cemetery_points: [] as any[],
        loading: false,
        error: null as string | null,
    }),

    getters: {
        hasCemetery: (state) => state.cemetery !== null,
    },

    actions: {
        set_cemetery(data: CemeteryType | null) {
            this.cemetery = data
        },

        set_cemetery_cards(data: any[]) {
            this.cemetery_cards = data
        },

        set_cemetery_points(data: any[]) {
            this.cemetery_points = data
        }
    },

    persist: true
})